import React, { useRef, useState } from "react";
import Create from "../Assets/CreateTask.svg";
import Filter from "../Assets/Filter.svg";
import "../Styles/Task/TaskPageTopBar.css";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { createNewForm } from "../Redux/Reducer/FormSlices";
import { useDispatch } from "react-redux";
import { BsSortDown } from "react-icons/bs";
import { IoCalendarOutline } from "react-icons/io5";
import { BiEditAlt } from "react-icons/bi";
import { PiClockCounterClockwise } from "react-icons/pi";
import { BsCalendarDate } from "react-icons/bs";
import { PiSubtitlesThin } from "react-icons/pi";
import { TfiTime } from "react-icons/tfi";
import { MdOutlineEditNote } from "react-icons/md";

const FormPageTopBar = () => {
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const URl = process.env.REACT_APP_API;
  const userId = localStorage.getItem("userId");
  const [openSort, setOpenSort] = useState(false);
  
  const dropdownRef = useRef(null);
  const handelCreateForm = () => {
    axios
      .post(`${URl}/forms/${userId}`, {
        formTitle: "Untitled form",
        formDescription: "Untitled form from Stacia Form",
      })
      .then((response) => {
        dispatch(createNewForm(response.data.createdNewForm));
        navigate(`/create-form/${response.data.createdNewForm._id}/question`);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const location = useLocation().pathname;

  return (
    <>
      <div className="taskpage-topbar">
        <div className="task-tabs">
          {/* <div
            className="task-tab"
            style={{
              color: location === "/forms/list" ? "#1B51BB" : "#8493B2",
              fontWeight: location === "/forms/list" ? "600" : "500",
            }}
            onClick={() => {
              navigate("/forms/list");
            }}
          >
            List
            {location === "/forms/list" && <div className="form-underline"></div>}
          </div>
          <div
            className="task-tab"
            style={{
              color: location === "/forms/folder" ? "#1B51BB" : "#8493B2",
              fontWeight: location === "/forms/folder" ? "600" : "500",
            }}
            onClick={() => {
              navigate("/forms/folder");
            }}
          >
            Folders
            {location === "/forms/folder" && <div className="form-underline"></div>}
          </div> */}
        </div>

        <div className="taskCTA">
          <div style={{ display: "flex", alignItems: "center", border: '1px solid #8493B2', width: '40px', height: '40px', borderRadius: '4px', justifyContent: 'center', cursor: 'pointer' }} onClick={() => setOpenSort(!openSort)}>
            <BsSortDown color="#8493B2" size={22} />
          </div>
          <div className="create-task" onClick={() => handelCreateForm()}>
            <img src={Create} alt="" />
            <div className="btn-text">Create Form</div>
          </div>
          {
            openSort && <div className="sort-modal" ref={dropdownRef}>
              <ul>
                <li><IoCalendarOutline size={18} /><span>All Forms</span></li>
                <li><BiEditAlt size={18} />
                  <span>Last Edit</span></li>
                <li><PiClockCounterClockwise size={18} />
                  <span>Submissions count</span></li>
                <li><BsCalendarDate size={18} />
                  <span>Last submission</span></li>
                <li><PiSubtitlesThin size={18} />
                  <span>Title</span></li>
                <li> <TfiTime size={18} />
                  <span>Created time</span></li>
                <li> <MdOutlineEditNote size={18} />
                  <span>Modified time</span></li>
              </ul>
            </div>
          }
        </div>
      </div>
      <Outlet />
    </>
  );
};

export default FormPageTopBar;
